// extracted by mini-css-extract-plugin
export default {"content":"_GDPR_content__h3dR-","accept":"_GDPR_accept__nsgnl","dismiss":"_GDPR_dismiss__P5QUn"};